import { useEffect, useState } from "react";
import { ewaiverApi } from "../api/ewaiver.service";
import { EmailSectionItem } from "../api";

export interface DetailEwaiverType {
  event_id: string;
  event_name: string;
  event_name_vi: string;
  is_have_online_checkin: number;
  start_checkin_online_date: string;
  end_checkin_online_date: string;
  authorization_form_url: string | null;
  disclaimer_form_url: string | null;
  t_and_c_link: string | null;
  ewaiver_banner_url: string;
  url_html: string;
  waiver_sign_required: boolean;
  is_sent_to_authorizer: boolean;
  send_bib_via_email: boolean;
  is_show_send_ewaiver?: boolean;
  is_show_send_qrcode?: boolean;
  is_change_pickup_method: boolean;
  number_of_times_change_pickup: number;
  is_change_authorized_info: boolean;
  number_of_times_update_authorized_info: number;
  only_authorize: boolean;
  email_section: EmailSectionItem[];
  kyc_required: boolean;
  kyc_ocr_limit: number;
  kyc_face_matching_limit: number;
  kyc_face_matching_ratio: number;
}

export const useDetailEwaiver = (id: string) => {
  const [data, setData] = useState<DetailEwaiverType | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = async (id: string) => {
    setLoading(true);
    try {
      const res = await ewaiverApi.detail(id);
      const data = res?.data;

      setData(data?.data);
    } catch (error: any) {
      console.log("Get detail ewaiver failed:", error);

      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(id);
  }, [id]);

  return { data, fetchData, loading, error };
};
